import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { actorInfo } from '../../../mocks/portfolio';

const Contact = () => {
  return (
    <footer id="contact" className="bg-black text-white rounded-t-[40px]">
      <div className="max-w-7xl mx-auto px-8 py-16">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Left Column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="md:col-span-1"
          >
            <h3 className="font-serif text-4xl md:text-5xl font-light mb-4">
              Let's Work Together
            </h3>
            <p className="text-gray-400 text-base mb-6">
              Available for film, television, and theater projects
            </p>
            <a 
              href="https://www.dropbox.com/scl/fi/mxrt6ovce2sllqg0ftxb7/Resume-Jordan-Destin-MMPR_1_.pdf?rlkey=pzujfba4eihxqd4m398ukxf5r&st=t3lujdeh&dl=0"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-3 bg-white text-black rounded-full font-medium hover:bg-gray-200 transition-colors duration-300 cursor-pointer whitespace-nowrap flex items-center gap-2 inline-flex"
            >
              <i className="ri-file-text-line"></i>
              View Resume
            </a>
          </motion.div>

          {/* Center Column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            <h4 className="text-sm uppercase tracking-widest mb-6 text-gray-400">Quick Links</h4>
            <nav className="space-y-4">
              <a href="#demo-reel" className="block text-base hover:text-burgundy transition-colors duration-300 underline cursor-pointer">
                Demo Reel
              </a>
              <a href="#press" className="block text-base hover:text-burgundy transition-colors duration-300 underline cursor-pointer">
                Press Kit
              </a>
              <Link to="/filmography" className="block text-base hover:text-burgundy transition-colors duration-300 underline cursor-pointer">
                Filmography
              </Link>
              <a href="https://www.imdb.com/name/nm7411796/" target="_blank" rel="nofollow noopener noreferrer" className="block text-base hover:text-burgundy transition-colors duration-300 underline cursor-pointer">
                IMDb Profile
              </a>
              <a href="#bio" className="block text-base hover:text-burgundy transition-colors duration-300 underline cursor-pointer">
                Biography
              </a>
            </nav>
          </motion.div>

          {/* Right Column */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <h4 className="text-sm uppercase tracking-widest mb-6 text-gray-400">Representation</h4>
            
            {/* Primary Representation */}
            <div className="space-y-4 mb-6">
              <div>
                <div className="font-semibold text-base">{actorInfo.agent}</div>
                <div className="text-sm text-gray-400">{actorInfo.representation}</div>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-300">
                <i className="ri-mail-line w-5 h-5 flex items-center justify-center"></i>
                <a href={`mailto:${actorInfo.agentEmail}`} className="hover:text-burgundy transition-colors cursor-pointer">
                  {actorInfo.agentEmail}
                </a>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-300">
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
                <a href={`tel:${actorInfo.agentPhone}`} className="hover:text-burgundy transition-colors cursor-pointer">
                  {actorInfo.agentPhone}
                </a>
              </div>
            </div>

            {/* Second Representation */}
            <div className="space-y-4 mb-8 pt-6 border-t border-gray-800">
              <div>
                <div className="font-semibold text-base">{actorInfo.secondAgent}</div>
                <div className="text-sm text-gray-400">{actorInfo.secondRepresentation}</div>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-300">
                <i className="ri-mail-line w-5 h-5 flex items-center justify-center"></i>
                <a href={`mailto:${actorInfo.secondAgentEmail}`} className="hover:text-burgundy transition-colors cursor-pointer">
                  {actorInfo.secondAgentEmail}
                </a>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-300">
                <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
                <a href={`tel:${actorInfo.secondAgentPhone}`} className="hover:text-burgundy transition-colors cursor-pointer">
                  {actorInfo.secondAgentPhone}
                </a>
              </div>
            </div>

            {/* Social Media */}
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/jordandestin_/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white flex items-center justify-center hover:bg-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href="https://www.facebook.com/JordanDestin2.0"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white flex items-center justify-center hover:bg-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
              <a
                href="https://x.com/jordandestin"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white flex items-center justify-center hover:bg-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-twitter-x-line text-lg"></i>
              </a>
              <a
                href="https://www.imdb.com/name/nm7411796/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="w-10 h-10 rounded-full border-2 border-white flex items-center justify-center hover:bg-white hover:text-black transition-all duration-300 cursor-pointer"
              >
                <i className="ri-film-line text-lg"></i>
              </a>
            </div>
          </motion.div>
        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-500">
          <div>© 2025 {actorInfo.name}. All rights reserved.</div>
          <div>
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Contact;